



























import Vue from "vue";
import { MetaInfo } from "vue-meta";
import AlertService from "@/services/libs/AlertService";
import UserService from "@/services/UserSerivce";
import PubSub from "pubsub-js";

export default Vue.extend({
  name: "Tabs",
  metaInfo(): MetaInfo {
    return {
      title: this.title,
    };
  },
  props: {
    title: {
      type: String,
      default: "Detailseite",
    },
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data: function () {
    return {
      activeTab: 0,
      editable: false,
      editMode: false,
      agKommune: "undefined",
      stammdaten: {},
      dokumente: [],
      konzepte: [],
    };
  },
  mounted() {
    PubSub.unsubscribe("bearbeiten");
    PubSub.subscribe("bearbeiten", this.onChangemode);
  },
  beforeMount() {
    // set mode
    if (!UserService.hasReadPermission()) {
      // no read permission -> redirect
      this.$router.push({ name: "KommunenMain" });
      AlertService.info("Keine Leserechte vorhanden...");
      return;
    } else if (UserService.hasWritePermission()) {
      // has read and write permission
      this.editable = true;
    }

    // set edit mode by query parameter
    this.editMode = this.$route.query.editMode === "true" ? true : false;
    this.agKommune = String(this.$route.query.agKommune);

    // set open tab by query parameter
    if (this.$route.query.tab && typeof this.$route.query.tab == "string") {
      this.activeTab = Number.parseInt(this.$route.query.tab);
    }
  },
  watch: {
    editMode() {
      this.setRoute();
    },
    activeTab() {
      this.setRoute();
    },
  },
  methods: {
    onChangemode(sub: string, mode: boolean) {
      this.editMode = mode;
    },
    setRoute() {
      this.$router.replace({
        name: this.$router.currentRoute.name || "Detail",
        params: { id: String(this.id) },
        query: {
          editMode: String(this.editMode),
          tab: String(this.activeTab),
          agKommune: String(this.agKommune),
        },
      });
    },
  },
});
